import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import './Profile.css';

const Profile = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [selectedSociety, setSelectedSociety] = useState('');
  const [societies, setSocieties] = useState([]);
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    try {
      const storedProfileData = localStorage.getItem('profileData');
      if (!storedProfileData) {
        throw new Error('No profile data found');
      }

      const parsedData = JSON.parse(storedProfileData);
      setProfileData(parsedData);
      
      if (parsedData.Orgs && parsedData.Orgs.length > 0) {
        setSocieties(parsedData.Orgs);
        
        const currentSocietyId = localStorage.getItem('societyId');
        setSelectedSociety(currentSocietyId || parsedData.Orgs[0].OrgId);
      }
    } catch (error) {
      console.error('Error loading profile data:', error);
      setError('Failed to load profile data');
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSocietyChange = (e) => {
    const newSocietyId = e.target.value;
    setSelectedSociety(newSocietyId);
    localStorage.setItem('societyId', newSocietyId);
    window.dispatchEvent(new Event('societyChange'));
    window.location.reload();
  };

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      setError('Failed to logout');
    } finally {
      setIsLoggingOut(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!profileData) return <div>No profile data available</div>;

  return (
    <DashboardLayout>
      <div className="profile-container">
        <div className="profile-card">
          <div className="profile-header">
            <h2>Profile</h2>
          </div>

          <div className="profile-details">
            <div className="detail-group">
              <label>Name</label>
              <p>{profileData.name}</p>
            </div>

            <div className="detail-group">
              <label>Email</label>
              <p>{profileData.email}</p>
            </div>

            <div className="detail-group">
              <label>Organization</label>
              <div className="society-selector">
                <select
                  value={selectedSociety}
                  onChange={handleSocietyChange}
                  className="society-select"
                >
                  <option value="">Select a society</option>
                  {societies.map((society) => (
                    <option key={society.OrgId} value={society.OrgId}>
                      {society.OrgName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="profile-actions">
            <button 
              className="logout-btn" 
              onClick={handleLogout}
              disabled={isLoggingOut}
            >
              {isLoggingOut ? 'Logging out...' : 'Logout'}
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Profile; 